import EbiTempura from "./../../../image/hotDishes/EbiTempura.webp";
import ikaFurai from "./../../../image/hotDishes/ikaFurai.webp";
import kungPao from "./../../../image/hotDishes/kungPao.webp";
import Midii from "./../../../image/hotDishes/Midii.webp";

export const imagesHotDishes = {
    EbiTempura:EbiTempura,
    ikaFurai:ikaFurai,
    kungPao:kungPao,
    Midii:Midii,
}